import { Link } from 'react-router-dom'
import { PageLayout } from '@/shared/components/PageLayout'
import { Button } from '@/components/ui/button'
import { PAGE_URLS } from '@/lib/constants'
import { content } from '@/lib/content'

export default function NotFoundPage() {
  return (
    <PageLayout title={content.notFound.seo.title}>
      <div className="py-32">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-9xl font-bold text-gray-300 mb-4">{content.notFound.heading}</h1>
          <h2 className="text-4xl font-bold mb-6">{content.notFound.subheading}</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-md mx-auto">
            {content.notFound.description}
          </p>
          <Link to={PAGE_URLS.HOME}>
            <Button size="lg">{content.notFound.button}</Button>
          </Link>
        </div>
      </div>
    </PageLayout>
  )
}
